// extracted by mini-css-extract-plugin
export default {"titleConfig":"DropdownUser_titleConfig__rmNmH","radioConfig":"DropdownUser_radioConfig__CHmPE","purpleButton":"DropdownUser_purpleButton__cOQl6"};